import {  SellerInfo, StylistInfo, UserInfo } from "@/types/AppTypes";
import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  user: {} as UserInfo,
  isAuthenticated: false,
  distributorInfo: {} as SellerInfo,
  stylistInfo: {} as StylistInfo,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = action.payload?.email ? true : false;
    },
    clearUser: (state) => {
      state.user = {} as UserInfo;
      state.isAuthenticated = false;
      state.distributorInfo = {} as SellerInfo;
      state.stylistInfo = {} as StylistInfo;
    },
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setDistributorInfo: (state, action) => {
      state.distributorInfo = action.payload;
    },
    setStylistInfo: (state, action) => {
      state.stylistInfo = action.payload;
    },
  },
});

export const { setUser, clearUser, setIsAuthenticated, setDistributorInfo, setStylistInfo } = authSlice.actions;

export default authSlice.reducer;
